import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
} from "chart.js";
import { validateArray } from "../../utils/validate";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ChartDataLabels);

const fixedColors = [
  "#00B000",
  "#FF3333",
  "#3377FF",
  "#FF9933",
  "#993399",
  "#FF99CC",
  "#33CCCC",
  "#FFFF66",
  "#339999",
  "#993333",
  "#999933",
  "#FF33FF",
  "#CC6666",
  "#66FF66",
  "#6666CC",
  "#FFCC66",
  "#99FF66",
  "#666699",
  "#FF66AA",
  "#33BBBB",
  "#BBFF66",
  "#FF6666",
  "#996633",
  "#FF9966",
  "#339966",
];

const prepareChartData = (datal) => {
  const labels = datal.map((cliente) => cliente.option);
  const datasets = [];

  const dataAux = datal.map((cliente) => {
    return cliente.cantidadMes.reduce(
      (total, item) => total + (item.cantidad ?? 0),
      0
    );
  });

  // Repetir colores en caso de más de 3
  const backgroundColors = labels.map((_, index) =>
    fixedColors[index % fixedColors.length]
  );

  datasets.push({
    label: "Total",
    data: dataAux,
    backgroundColor: backgroundColors,
  });

  return {
    labels: labels,
    datasets: datasets,
  };
};

const ChartPieVertical = ({ data, listY, title, onClick, generalData }) => {
  const chartData = validateArray(data)
    ? prepareChartData(data)
    : { labels: [], datasets: [] };

  // También aplicar colores a datalabels
  const backgroundColors = chartData.labels.map(
    (_, index) => fixedColors[index % fixedColors.length]
  );

  const footer = (tooltipItems) => {
    let list = data.find((item) => item.option === tooltipItems[0].label);
    if (list) {
      const cantidadMes = list.cantidadMes.reduce(
        (total, item) => total + (item.cantidad ?? 0),
        0
      );
      return `Total: ${cantidadMes}`;
    }
    return "";
  };

  return (
    <Pie
      style={{ maxHeight: "650px", overflowX: "auto" }}
      options={{
        plugins: {
          title: {
            display: false,
            text: title,
          },
          datalabels: {
            color: "#fff",
            formatter: (value, context) => {
              const total = context.chart.data.datasets[0].data.reduce(
                (acc, val) => acc + (isNaN(val) ? 0 : val),
                0
              );
              const percentage =
                total > 0 ? ((value / total) * 100).toFixed(2) : 0;
              return `${percentage}%`;
            },
            font: {
              size: 20,
            },
            anchor: "center",
            align: "center",
            backgroundColor: backgroundColors, // 🔴🟢🔵 colores fijos
          },
          tooltip: {
            callbacks: {
              footer: footer,
            },
          },
          legend: {
            position: "top",
            display: false,
          },
        },
        responsive: true,
        onClick: function (_, element) {
          if (validateArray(element)) {
            onClick(
              chartData.labels[element[0].index],
              listY[element[0].datasetIndex]
            );
          }
        },
      }}
      data={{ ...chartData }}
    />
  );
};

export default ChartPieVertical;